import BBookIcon from './BBookIcon'
import { useT } from '../hooks'

const ICONS = { danger: 'critical', warning: 'warning', muted: 'info' }

// The alerts the admin API evaluates every minute (and sends to Slack), shown where the risk is read.
const BBookAlertBanners = ({ alerts }) => {
  const { t } = useT()
  if (!alerts) return null
  const banners = []
  if (alerts.engine_down)
    banners.push({ key: 'engine_down', level: 'danger', text: t('pages.b_book_pnl.alerts.engine_down', { time: new Date(alerts.engine_down_since).toLocaleTimeString('fr-FR') }) })
  if (alerts.rerouted_last_10m > 0)
    banners.push({ key: 'rerouted', level: 'warning', text: t('pages.b_book_pnl.alerts.rerouted', { count: alerts.rerouted_last_10m }) })
  if (!alerts.watching)
    banners.push({ key: 'not_watching', level: 'muted', text: t('pages.b_book_pnl.alerts.not_watching') })

  return banners.map(({ key, level, text }) => (
    <div key={key} className={`b_book_pnl_alert b_book_pnl_alert_${level}`} role={level === 'muted' ? 'status' : 'alert'}>
      <BBookIcon name={ICONS[level]} size={20} />
      <span><strong>{t(`pages.b_book_pnl.alerts.level_${level}`)}</strong> {text}</span>
    </div>
  ))
}

export default BBookAlertBanners
